import React, { useState, useEffect } from 'react';
    import { auth } from '../firebaseConfig';
    import { signOut } from 'firebase/auth';
    import { useNavigate } from 'react-router-dom';
    import AdminLayout from './AdminLayout';
    import AdminHeroManagement from './AdminHeroManagement';
    import AdminExperiences from './AdminExperiences';
    import AdminReservasSedes from './AdminReservasSedes';
    import AdminReservations from './AdminReservations';
    import AdminMenuRecommendations from './AdminMenuRecommendations';
    import AdminMenuSedes from './AdminMenuSedes';
    import AdminMenuManagement from './AdminMenuManagement';
    import AdminDishManagement from './AdminDishManagement';
    import AdminEventSpaces from './AdminEventSpaces';
    import AdminPromotions from './AdminPromotions';
    import AdminSocialLinks from './AdminSocialLinks';
    import AdminReviews from './AdminReviews';
    import AdminBookings from './AdminBookings'; // Import new component
    import AdminReservationsManagement from './AdminReservationsManagement'; // Import the new component
    import AdminPromotionBookings from './AdminPromotionBookings';
    import AdminUserManagement from './AdminUserManagement'; // Import AdminUserManagement
   
   
    function AdminDashboard({ userRole, userPermissions }) { // Accept userRole and userPermissions props
      const [currentSection, setCurrentSection] = useState(null);
      const navigate = useNavigate();
   
      useEffect(() => {
        const getFirstPermittedSection = () => {
          const permittedSections = Object.keys(userPermissions).filter(permission =>
      userPermissions[permission]);
          return permittedSections.length > 0 ? permittedSections[0] : null;
        };
   
        if (Object.keys(userPermissions).length > 0 && currentSection === null) {
          setCurrentSection(getFirstPermittedSection());
        }
      }, [userPermissions, currentSection]);
   
      const handleLogout = async () => {
        try {
          await signOut(auth);
          console.log('Sesión cerrada exitosamente!');
          navigate('/admin');
        } catch (error) {
          console.error('Error al cerrar sesión:', error);
        }
      };
   
      const renderSection = () => {
        switch (currentSection) {
          case 'hero':
            return <AdminHeroManagement />;
          case 'experiences':
            return <AdminExperiences />;
          case 'reservasSedes':
            return <AdminReservasSedes />;
          case 'reservations':
            return <AdminReservations />;
         case 'eventBookings': // New case for AdminBookings
            return <AdminBookings />;
          case 'menuRecommendations':
            return <AdminMenuRecommendations />;
          case 'menuSedes':
            return <AdminMenuSedes />;
          case 'menuManagement':
            return <AdminMenuManagement />;
          case 'dishManagement':
            return <AdminDishManagement />;
          case 'eventSpaces':
            return <AdminEventSpaces />;
          case 'promotionsConfig':
            return <AdminPromotions />;
          case 'promotionBookings':
            return <AdminPromotionBookings />;
          case 'socialLinks':
            return <AdminSocialLinks />;
          case 'reviews':
            return <AdminReviews />;
          case 'reservationsManagement':
            return <AdminReservationsManagement />;
          case 'userManagement': // New case for user management
            return <AdminUserManagement />;
          default:
            return currentSection ? <AdminHeroManagement /> : <div>Selecciona una sección del
      menú.</div>;    }
      };
   
      return (
        <AdminLayout onLogout={handleLogout} onSelectSection={setCurrentSection}
      userRole={userRole} userPermissions={userPermissions}>
          {renderSection()}
        </AdminLayout>
      );
    }

    export default AdminDashboard;